import Alpine from 'alpinejs';

const model = {
  disableDownload: false,
  showDownloadBox: false,
  loading: true,
  downloadBox: { heading: 'Your download has started!', message: 'Open the downloaded file to start your analysis.', downloadDisabled: false},

  downloadClicked() {
    this.showDownloadBox = true;
  },
  init() {
    const isPlatformMatch = (window as any).isPlatformMatch as boolean;

    if (isPlatformMatch === false) {
      this.showDownloadBox = true;
      this.disableDownload = true;

      this.downloadBox.heading = 'Your operating system is not supported by this download.';
      this.downloadBox.message = 'Please try an alternative link.';
      this.downloadBox.downloadDisabled = true;
    }

    this.loading = false;
  }
};

Alpine.data('model', () => model);
Alpine.start();
